module.exports = __webpack_public_path__ + "img/avatar0.efc716be.png";